<!--
  --
  -- カード情報入力コンポーネント
  --
  -->
<template>
  <div class="c-credit-card">
    <div class="c-credit-card-form">

      <!-- カード番号 -->
      <c-number-field
        label="カード番号"
        v-model="form.number"
        :rules="[rule.required('カード番号')]"
        :Flags="Flags"
      />

      <!-- カード名義人 -->
      <v-text-field
        label="カード名義人"
        v-model="form.holdername"
        :rules="[rule.required('カード名義人')]"
        :disabled="Flags.disabled"
      />

      <div class="d-flex flex-column flex-sm-row mx-n2">
        <div class="px-2">

          <!-- 有効期限 -->
          <c-expire-field
            label="有効期限"
            v-model="form.expire"
            :rules="[rule.required('有効期限'), rule.cardExpire]"
            :Flags="Flags"
          />

        </div>
        <div class="px-2 flex-grow-1">

          <!-- セキュリティコード -->
          <v-text-field
            label="セキュリティコード"
            v-model="form.cvc"
            :rules="[rule.required('セキュリティコード'), rule.cardCvc]"
            :disabled="Flags.disabled"
          />

        </div>
      </div>
    </div>

    <aside class="c-credit-card-brands">
      <div class="caption text--secondary">次のクレジットカードがご利用頂けます。</div>

      <!-- 利用できるカードブランド一覧 -->
      <div class="c-credit-card-brands-catalog">
        <div
          v-for="brand in acceptedBrands"
          :key="brand.code"
          class="c-credit-card-brands-catalog-item"
        >
          <img
            class="c-credit-card-brand-logo is-bordered"
            :src="brand.logo"
          />
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
import CNumberField from './CNumberField'
import CExpireField from './CExpireField'

import BRANDS from './brands'

export default {
  name: 'CCreditCardFields',
  components: {
    CNumberField,
    CExpireField
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    brands: {
      type: Array,
      default: () => []
    },
    Flags: {
      disabled: false
    }
  },
  computed: {
    /**
     * 取り扱いができるカードブランド
     */
    acceptedBrands () {
      const result = this.brands.map(brand => {
        const b = BRANDS.find(item => item.code === brand)
        if (!b) {
          throw new Error(`Brand not supported. ${brand}`)
        }
        return b
      })
      return result
    }
  }
}
</script>

<style lang="scss">
.c-credit-card {
  display: flex;
  flex-flow: column nowrap;
  margin-left: -.5rem;
  margin-right: -.5rem;

  > .c-credit-card-form, > .c-credit-card-brands {
    padding-left: .5rem;
    padding-right: .5rem;
  }

  > .c-credit-card-form {
    order: 1;
  }

  > .c-credit-card-brands {
    order: 0;
    margin-bottom: 8px;
  }

  .c-credit-card-brand-logo {
    display: block;
    width: 40px;
    height: 28px;
    object-fit: contain;
    background-color: white;
    border-radius: 3px;

    &.is-bordered {
      padding: 1px;
      border: solid thin rgb(black, .15);
    }
  }
}

.c-credit-card-brands-catalog {
  display: flex;
  flex-flow: row wrap;
  margin: 2px -2px;

  > .c-credit-card-brands-catalog-item {
    padding: 2px;
  }
}
</style>
